import { CHOOSE_CAMPAIGN_TABLE_GRID } from 'modules/experiments/constants';
import { CHOOSE_CAMPAIGN_COLUMNS, CHOOSE_CAMPAIGN_TABLE_COLUMN } from 'modules/experiments/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { HeaderRowCell } from 'modules/experiments/components/pages/index/sections/table/HeaderRowCell';

import { CellPadding, InPageHeaderGridRow } from '../styled';

type HeaderRowProps = {
  sortedBy: CHOOSE_CAMPAIGN_COLUMNS;
  setSortedBy: (sortBy: CHOOSE_CAMPAIGN_COLUMNS) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  columns: CHOOSE_CAMPAIGN_TABLE_COLUMN[];
};

export const HeaderRow = ({
  sortedBy,
  setSortedBy,
  sortDirection,
  setSortDirection,
  columns,
}: HeaderRowProps) => {
  return (
    <InPageHeaderGridRow gridLayout={CHOOSE_CAMPAIGN_TABLE_GRID}>
      {columns.map((column) => (
        <CellPadding key={column.id}>
          <HeaderRowCell
            column={column}
            columnId={column.id}
            key={column.id}
            isActiveSortColumn={column.id === sortedBy}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            setSortedBy={setSortedBy}
            inPage={true}
          />
        </CellPadding>
      ))}
    </InPageHeaderGridRow>
  );
};
